export enum CardiacArrestConstants {
  UPDATE_END_CPR = 'cardiacArrest/UPDATE_END_CPR',
  UPDATE_AIRWAY = 'cardiacArrest/UPDATE_AIRWAY',
  UPDATE_DEFIB = 'cardiacArrest/UPDATE_DEFIB',
  UPDATE_AMIODARONE = 'cardiacArrest/UPDATE_AMIODARONE',
  UPDATE_EPI = 'cardiacArrest/UPDATE_EPI',
  UPDATE_ATROPINE = 'cardiacArrest/UPDATE_ATROPINE',
  UPDATE_INTUBATION = 'cardiacArrest/UPDATE_INTUBATION',
  UPDATE_INITIATE_IV = 'cardiacArrest/UPDATE_INITIATE_IV',
  UPDATE_BVM = 'cardiacArrest/UPDATE_BVM',
}
